export default {
  common: {
    language: 'Language',
    langZhCN: '简体中文',
    langEnUS: 'English',
    confirm: 'OK',
    backToSignIn: 'Back to Sign In',
    login: 'Sign In',
    username: 'Username',
    password: 'Password',
    success: 'Success',
    systemErrorRetry: 'System error. Please try again later.',
  },
  loading: {
    dataLoading: 'Loading data...',
    loginLoading: 'Signing in...',
  },
  app: {
    titles: {
      forgetPassword: 'Forgot Password',
      resetPassword: 'Reset Password',
      bindAccount: 'First {accountType} login, please bind your account',
    },
    accountTypes: {
      wx: 'WeChat',
      wxWork: 'WeCom',
      dingTalk: 'DingTalk',
      alipay: 'Alipay',
      other: 'Other',
    },
  },
  forgetPassword: {
    tip: 'Please fill in the information below. We will send a password reset link to your email.',
    placeholders: {
      name: 'Enter your name',
      staffNo: 'Enter your staff/student number',
      email: 'Enter your recovery email address',
    },
    submit: 'Submit',
    resultTitle: 'Password Reset',
    resultDescription: 'A password reset email has been sent. Please check your inbox and follow the link.',
    errors: {
      resetFailed: 'Password Reset Failed',
      retryLater: 'Password reset failed. Please try again later.',
      systemError: 'System error. Please try again later.',
      invalidEmail: 'Please enter a valid email address',
    },
    rules: {
      nameRequired: 'Please enter your name',
      staffNoRequired: 'Please enter your staff/student number',
      emailRequired: 'Please enter your recovery email address',
    },
  },
  signIn: {
    placeholders: {
      username: 'Enter username',
      password: 'Enter password',
      captcha: 'Enter verification code',
    },
    defaultPasswordTip: {
      line1: 'Default password is Fap + last 6 digits of ID + !',
      line2: 'Example: Fap123456! or Fap12345x!.',
    },
    actions: {
      forgotPassword: 'Forgot Password',
      bind: 'Bind',
      otherSignInMethods: 'Other Sign-in Methods',
    },
    slideVerifyText: 'Slide to complete the puzzle above',
    rules: {
      usernameRequired: 'Username is required',
      passwordRequired: 'Password is required',
      captchaRequired: 'Verification code is required',
    },
    errors: {
      captchaInitFailed: 'Captcha initialization failed',
      bindError: 'Binding Error',
      configErrorTitle: 'Error',
      configErrorDescription: 'System configuration error',
    },
  },
  changePassword: {
    tip: 'For account security, please change your initial password. New password must be 7-16 chars and include upper/lowercase letters, numbers, and symbols.',
    placeholders: {
      password: 'Enter new password',
      passwordConfirm: 'Re-enter new password',
      passwordConfirmAgain: 'Enter new password again',
    },
    actions: {
      submit: 'Change Password',
      resetSubmit: 'Reset Password',
    },
    rules: {
      passwordRequired: 'Password is required',
      passwordNotSameAsOld: 'New password cannot match old password',
      passwordInvalid: 'Password does not meet requirements',
      passwordInvalidDetailed: 'Password must be 7-16 chars and include upper/lowercase letters, numbers, and symbols',
      passwordConfirmRequired: 'Password confirmation is required',
      passwordConfirmNotMatch: 'The two passwords do not match!',
      passwordConfirmNotMatchPlain: 'The two passwords do not match',
    },
    errors: {
      resetLinkInvalid: 'Reset link is invalid or expired. Please go back to sign-in and request a new one.',
      resetFailed: 'Reset Password Failed',
      resetRetryLater: 'Password reset failed. Please try again later.',
      resetSuccess: 'Password reset succeeded!',
    },
  },
  recoveryEmail: {
    tip: 'Please set a recovery email so you can receive password reset links if needed.',
    placeholders: {
      email: 'Enter recovery email',
      verificationCode: 'Enter email verification code',
    },
    actions: {
      resend: 'Resend',
      sendEmail: 'Send Email',
      verifyAndSave: 'Verify and Save',
      skip: 'Skip',
    },
    dialogs: {
      sendFailed: 'Send Failed',
      sendSuccess: 'Sent',
      verifyFailed: 'Verification Failed',
      setupSuccess: 'Recovery email set successfully.',
      emailSentTemplate: 'A verification email has been sent to {email}. Please enter the code from your email to complete setup.',
      sendRetryLater: 'Send failed. Please try again later.',
      verifyRetryLater: 'Code verification failed. Please try again later.',
    },
    rules: {
      emailRequired: 'Recovery email is required',
      emailInvalid: 'Please enter a valid email address',
      verificationCodeRequired: 'Verification code is required',
    },
  },
  mobileCompletion: {
    tip: 'Please enter or review your mobile number to complete your account information. You can update it if needed. Sign-in will continue after submission.',
    placeholder: 'Enter an 11-digit mobile number',
    submit: 'Submit and Continue',
    mobileRequired: 'Mobile number is required',
    mobileInvalid: 'Enter a valid 11-digit mainland China mobile number',
    failed: 'Failed to Submit Mobile Number',
    expired: 'This operation has expired. Please start sign-in again.',
    retryLater: 'Submission failed. Please try again later.',
  },
  result: {
    back: 'Back',
  },
};
